import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { STALE_TIME } from './common'
import * as PlaceImageKeys from '../reactQueryKeys/placeImage'

import { getGooglePlaceImages } from 'tripPlanner/api/places'
import {
  GetGooglePlaceImagesError,
  GetGooglePlaceImagesResponse,
} from 'tripPlanner/api/places/types'

export type UsePlaceImagesParams = {
  placeId: string
  count?: number
  orientation?: 'landscape' | 'portrait' | 'all'
  maxWidthPx?: number
  tripId?: string
  tripItemId?: string
}

// This hook is used to fetch multiple images for a place when we only know the placeId
export const usePlaceImages = (
  params: UsePlaceImagesParams,
  options?: UseQueryOptions<
    GetGooglePlaceImagesResponse['result'],
    GetGooglePlaceImagesError,
    Array<App.Image>,
    ReturnType<typeof PlaceImageKeys.googlePlaceImages>
  >,
) => {
  const {
    placeId,
    count = 1,
    orientation = 'all',
    maxWidthPx,
    tripId,
    tripItemId,
  } = params
  return useQuery({
    queryKey: PlaceImageKeys.googlePlaceImages(
      placeId,
      count,
      orientation,
      maxWidthPx,
    ),
    queryFn: () =>
      getGooglePlaceImages(
        placeId,
        count,
        orientation,
        maxWidthPx,
        tripId,
        tripItemId,
      ),
    staleTime: STALE_TIME,
    select: (data) =>
      data.map((image) => ({ id: image.name, url: image.photoUri })),
    ...options,
  })
}
